import { selectorFamily } from 'recoil';
import notificationsState from '../atoms/notifications';
import Notification, { LinkType } from '../../interfaces/Notification';

const unreadNotificationsByLinkTypeState = selectorFamily<Notification[], LinkType>({
  key: 'unreadNotificationsByLinkType',
  get: (type) => ({ get }) => {
    const notifications = get(notificationsState);
    return notifications.filter((notification) => type === notification.linkType && !notification.beenSeen);
  },
});

export { unreadNotificationsByLinkTypeState };
